import React from 'react';
import Icon from 'components/icon/icon'
import { connect } from 'react-redux'
import { getCurrentUser } from 'state/selectors/userSelectors'

import { getThumbUrl } from 'utils'

const ProfilePicture = props => {
    const {
        forceLight,
        userData,
        editable,
        account,
        url,
        users,
        handleImageChange,
        user,
        userId,
        allUsers,
        isTiny,
        size,
        isFromHassl
    } = props

    let thisUser = null
    
    if(user){
        thisUser = user
    }else if(userId){
        thisUser = allUsers[userId]
    }

    let imageSize = size ? size : 'thumb'

    if(isTiny){
        imageSize = 'tiny'
    }

    let emptyImageUrl = 'profile-empty-light'
    let emptyAccountUrl = 'account-empty-light'

    if(userData && userData.show_dark_ui && !forceLight){
        emptyImageUrl = 'profile-empty'
        emptyAccountUrl = 'account-empty'
    }

    let className = 'profile-image'
    let showInitials = false

    let imageUrls = []

    if(editable){
        className += ' editable'
    }

    if(account){
        className += ' account'
    }

    // TODO: this is a mess.

    if(isFromHassl){
        imageUrls = [document.base+'/images/hassl-notification.jpg']
    }else if(url){
        imageUrls = [url]
    }else{
        if(account){
            if(getThumbUrl(account, imageSize)){
                imageUrls = [getThumbUrl(account, imageSize)];
            }else{
                imageUrls = [document.base+`/images/${emptyAccountUrl}.jpg`];
            }
        }else{
            if(users){
                users.forEach(user => {
                    if(!user){
                        return 
                    }
                    
                    if(imageUrls.length < 3){
                        if(user.id != userData.id){
                            if(getThumbUrl(user, imageSize)){
                                imageUrls.push(getThumbUrl(user, imageSize));
                            }else{
                                showInitials = user;
                                imageUrls.push(document.base+`/images/${emptyImageUrl}.jpg`);
                            }
                        }
                    }
                });

                if(imageUrls.length == 2){
                    if(getThumbUrl(userData, imageSize)){
                        imageUrls.push(getThumbUrl(userData, imageSize));
                    }else{
                        imageUrls.push(document.base+`/images/${emptyImageUrl}.jpg`);
                    }
                }
            }else{
                if(thisUser && getThumbUrl(thisUser, imageSize)){
                    imageUrls = [getThumbUrl(thisUser, imageSize)];
                }else{
                    imageUrls = [document.base+`/images/${emptyImageUrl}.jpg`];
                }				
            }

            if(!imageUrls.length){
                imageUrls = [document.base+'/images/profile-anonymous.jpg'];
            }
        }
    }

    return (
        <div className={ className }>
            <div>
                <div>
                    {
                        (showInitials && showInitials.first_name) ? 
                        <span className="initials">
                            { showInitials.first_name.charAt(0)+' '+showInitials.last_name.charAt(0) }
                        </span>
                        : null
                    }
                    {
                        props.editable &&
                        <div className="button-proxy">
                            <Icon name="fe-edit-2" />
                            <input type="file" onChange={e => {handleImageChange(e)}} />
                        </div>
                    }
                    <ul className={ 'images-list split-'+imageUrls.length }>
                        {
                            imageUrls.map((imageUrl, i) => {
                                return (
                                    <li key={i}>
                                        <img src={imageUrl} alt=""/>
                                    </li>
                                );
                            })
                        }
                    </ul>
                </div>
            </div>
        </div>
    );
};

function mapStateToProps(state){
  return {
	  allUsers: state.account.entities.users,
	  userData: getCurrentUser(state),
  };
}

export default connect(mapStateToProps)(ProfilePicture);


// WEBPACK FOOTER //
// ./src/components/profile/profile-picture.jsx